module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My thanks go to the staff at the Palace Green Library, Durham University for allowing me access to the Grey Papers; to the British Library; to the National Archives, Kew; and to the Surrey History Centre.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On a more personal level, this book could never have been completed without the love and support of my long-suffering wife Jen, who did not bat an eyelid when I told her I would need to go to the UK for two-and-a-half weeks to rustle through the papers of a general she had never heard of, for a book about a campaign that seemed impossibly obscure. By such love and support is history made.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f7eb17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgements.vue
// module id = 81
// module chunks = 0